import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/core-js/modules/es.array.iterator.js";
import "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/core-js/modules/es.promise.js";
import "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/core-js/modules/es.object.assign.js";
import "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/*
 * @Author: your name
 * @Date: 2020-03-04 14:30:51
 * @LastEditTime: 2020-03-06 14:26:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /fle-basic-template/src/main.js
 */
import Vue from 'vue';
import ElementUI from 'element-ui';
import VueAnalytics from 'vue-analytics';
import '@/assets/styles/index.scss';
import '@/assets/styles/index.scss';
import App from './App';
import store from './store';
import router from './router';
import _i18n from './lang';
import '@/assets/icons';
import '@/router/permission';
import { axiosRequest } from './util/axios-request';
import { util } from './util/util';
import mixin from './util/mixin';
import s from 'storejs';
import './util/directive';
import './util/origin-extend';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import VueClipboard from 'vue-clipboard2'; // 剪贴板

// 接入日志平台
var mode = process.env.MODE;
_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var ErrorCapture, capture;
  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        if (!(!['training'].includes(process.env.MODE) && process.env.NODE_ENV !== 'development')) {
          _context.next = 6;
          break;
        }
        _context.next = 3;
        return import('@flash-tools/error-capture');
      case 3:
        ErrorCapture = _context.sent.default;
        capture = new ErrorCapture({
          pid: process.env.ERROR_PID,
          mode: mode === 'trunk' ? 'development' : 'production',
          performance: true
          // igonre: params => {
          //   const { info } = params
          //   const stack = ['Network Error', 'removeChild'].some(v => info.stack.includes(v))
          //   if (stack) return true
          // }
        });

        Vue.use(capture);
      case 6:
      case "end":
        return _context.stop();
    }
  }, _callee);
}))();
Vue.prototype.$http = axiosRequest;
Vue.prototype.$util = util;
Vue.prototype.$p = util.permissionCheck;
Vue.prototype.$s = s;
Vue.use(ElementUI, {
  size: 'small',
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});
Vue.use(VueDOMPurifyHTML);
Vue.use(VueClipboard); // 剪贴板
Vue.config.productionTip = false;
Vue.mixin(mixin);
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});
Vue.use(VueAnalytics, {
  id: 'UA-183876102-2'
});